<template>
    <div class="materia-table-box order-materia-table-box">
        <el-table :data="showTableData" border size="mini" empty-text="暂无物料行信息" :header-cell-style="headerCellStyle"
            @selection-change="handleSelectionChange"
            :height="PAGESIZE.h-270">
            <el-table-column v-if="showBtnJDWH" type="selection" width="30"> </el-table-column>
            <el-table-column prop="rowNo" width="50" label="行号" fixed align="left"> </el-table-column>
          <!-- <el-table-column prop="code" label="物料编码" fixed :show-overflow-tooltip="true" width="120"> </el-table-column> -->
            <el-table-column prop="name" label="询价名称" fixed :show-overflow-tooltip="true"> </el-table-column>
          <!--
           <el-table-column prop="sspace" label="询价规格" :show-overflow-tooltip="true" width="120"> </el-table-column>
           <el-table-column prop="model" label="询价型号" :show-overflow-tooltip="true" width="120"> </el-table-column>
           <el-table-column prop="figueNumber" label="询价图号" :show-overflow-tooltip="true" width="120"> </el-table-column>
         -->
            <el-table-column prop="unit" label="计量单位" :show-overflow-tooltip="true" width="120"> </el-table-column>
            <el-table-column prop="zbsl" label="中标数量" :show-overflow-tooltip="true" width="120"> </el-table-column>
            <el-table-column prop="zbjg" label="中标价格" :show-overflow-tooltip="true"> </el-table-column>
            <el-table-column prop="zbTaxAmount" label="含税金额" :show-overflow-tooltip="true"> </el-table-column>
            <!-- <el-table-column prop="d" label="询价单号" :show-overflow-tooltip="true"> </el-table-column> -->
            <el-table-column prop="canProvide" label="是否可供货">
                <template slot-scope="scope">
                    <el-switch
                        size="mini"
                        v-if="editOrderFlag"
                        v-model="scope.row.colCanProvide"
                        active-color="#66cc99"
                        inactive-color="#999">
                    </el-switch>
                    <span v-if="!editOrderFlag">{{scope.row.colCanProvide?'是':'否'}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="provideDate" width="135px" label="计划送货日期">
                <template slot-scope="scope">
                    <el-date-picker
                        v-if="editOrderFlag"
                        class="table-edit-inputDate"
                        v-model="scope.row.provideDate"
                        size="mini"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                        type="date">
                    </el-date-picker>
                    <span v-if="!editOrderFlag">{{scope.row.provideDate}}</span>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="remark" label="行备注" :show-overflow-tooltip="true" width="130px">
                <template slot-scope="scope">
                    <el-input  v-if="editOrderFlag" size="mini" v-model="scope.row.remark" type="textarea" maxlength="100" :autosize="{ minRows: 1 }" class="table-edit-input"/>
                    <span v-if="!editOrderFlag">{{  scope.row.remark }}</span>
                </template>
            </el-table-column> -->
            <el-table-column prop="tsbz" label="供方特殊备注" :show-overflow-tooltip="true" width="130px"></el-table-column>
            <el-table-column prop="remark" label="订单交付进度说明" :show-overflow-tooltip="true" width="130px"></el-table-column>
            <el-table-column prop="bjwlmc" label="报价名称" :show-overflow-tooltip="true" width="130px"></el-table-column>
          <!--
          <el-table-column prop="bjgg" label="报价规格" :show-overflow-tooltip="true" width="130px"></el-table-column>
          <el-table-column prop="bjxh" label="报价型号" :show-overflow-tooltip="true" width="130px"></el-table-column>
          <el-table-column prop="bjth" label="报价图号" :show-overflow-tooltip="true" width="130px"></el-table-column>
           -->
          <el-table-column prop="accumulateQianshou" label="已签收数量" :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column prop="rukuNum" label="已入库数量" :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column prop="kaipiaoNum" label="已开票数量" :show-overflow-tooltip="true"> </el-table-column>
      </el-table>
      <!-- 进度维护弹框 -->
        <el-dialog :visible.sync="progressDialog.openDialog" width="800px" :title="'订单交付进度说明'" :close-on-click-modal="false">
            <el-form label-width="110px" ref="form" :model="progressDialog.form" v-loading="progressDialog.loading" :rules="progressDialog.rules" size="small">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="进度说明" prop="remark">
                            <el-input v-model="progressDialog.form.remark" type="textarea" maxlength="100" :autosize="{ minRows: 2 }" placeholder="请输入订单交付进度说明" />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="progressDialog.openDialog = false" size="small" :disabled="progressDialog.loading">取 消</el-button>
                <el-button type="primary" @click="submitProgressForm" size="small" :disabled="progressDialog.loading">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { orderMxList,gysUpdateList } from '@/api/omg/index.js';
import { delSupplierAddress } from '../../../api/gys/supplierAddress';
import moment from 'moment'
export default {
    props:['pageFlag','hId','orderInfo','editOrderFlag','showBtnJDWH'],
    data() {
        return {
            showTableData:[],
            selRows:[],
            progressDialog:{
                loading:false,
                openDialog:false,
                form:{
                    remark:''
                },
                rules:{},
            },

        };
    },
    computed: {
        PAGESIZE:function(){
            return this.$store.getters['app/sizeInfo'];
        },
    },
    created() {
        this.getList()
    },
    methods: {
        getList(){
            orderMxList({
                page: 1, //当前页码
                limit: 10000, //当前每页显示的数量
                objMap:{
                    finalOrderId:this.hId
                }

            }).then(({data:res})=>{
                if(res.code == 0){
                    let list = res.data || [];
                    let newList = []
                    console.log()
                    let fbData = null
                    if(this.orderInfo.publishOrderDate){
                        let darr = this.orderInfo.publishOrderDate.split(' ')
                        let dayTemp = moment(`${darr[0]} 00:00:00`).unix()*1000
                        fbData = dayTemp
                        // console.log(curSTime)
                        // console.log(moment(curSTime).format('YYYY-MM-DD'))
                    }

                    list.forEach((item,index)=>{
                        item['rowNo'] = index+1;
                        let commodity = {...item.commodity,productId:item.commodity.id};
                        delete commodity.id;
                        let bjinfo = item.bjinfo||{};
                        let bjObj ={
                            zbsl:bjinfo.zbsl || 0,  // 中标数量
                            zbjg:bjinfo.zbjg || 0,  // 中标价格
                            tsbz:bjinfo.remark || '',  // 供方特殊备注
                            bjwlmc:bjinfo.bjwlmc||'',           // 报价名称
                            bjgg:bjinfo.bjgg||'',           // 报价规格
                            bjxh:bjinfo.bjxh||'',           // 报价型号
                            bjth:bjinfo.bjth||'',           // 报价图号
                            provideDate:null,           // 计划送货日期
                        }
                        bjObj['zbTaxAmount'] = bjObj.zbsl*bjObj.zbjg;   // 中标含税金额
                        if(fbData && bjinfo.ghZq  ){ // 发布日期
                            let eTemp = fbData + Number(bjinfo.ghZq)*24*60*60*1000;
                            // console.log(moment(eTemp).format('YYYY-MM-DD'))
                            bjObj['provideDate'] = moment(eTemp).format('YYYY-MM-DD')    // 计划送货日期
                        }
                        newList.push({
                            ...item,
                            ...commodity,
                            colCanProvide:item.canProvide == '是'?true:false,
                            ...bjObj
                        })
                    })
                    console.log(newList)
                    this.showTableData = newList;
                }
            })
        },
        // 行选择
        handleSelectionChange(rows){
            this.selRows = [...rows]
        },
        // 打开维护进度弹框
        openProgressDialog(){
            if(!this.selRows.length){
                this.$fail('请至少选择一行数据！')
                return
            }
            this.progressDialog.form.remark = ''
            this.progressDialog.openDialog = true
        },
        // 提交进度维护数据
        async submitProgressForm(){
            // 订单编辑保存
			let prama = [];
			this.selRows.forEach((item)=>{
				prama.push({
					id:item.id,
					// canProvide:item.colCanProvide?'是':'否',
					// provideDate:item.provideDate,
					remark:this.progressDialog.form.remark || '',
				})
			})
            this.progressDialog.loading = true
			const { data: res } = await gysUpdateList(prama)
            this.progressDialog.loading = false
			if(res.code == 0){
                this.progressDialog.openDialog = false
				this.getList()
			}
        },
    },
    watch: {

    },
};
</script>
<style lang="scss">
.order-materia-table-box{
    // margin-top: 50px!important;
    // .gys-col{
    //     background: #ecf5ff;
    // }
    // .el-table--border::after {
    //     width: 1px;
    //     top: 0;
    //     right: 0;
    //     height: 100%;
    // }
    // .el-table--border .el-table__cell {
    //     border-right: 1px solid #82848a;
    // }
    .el-table--mini .el-table__cell{
        padding: 2px 0;
    }
    // .el-table--group, .el-table--border {
    //     border-top: 1px solid #82848a;
    //     border-left: 1px solid #82848a;
    // }
    .el-table {
        .cell{
            padding-left: 5px!important;
            padding-right: 5px!important;
            .table-edit-input{
                .el-input-group__append{
                    padding: 0 5px;
                }
            }

        }
    }
}
</style>
